module.exports = __webpack_public_path__ + "img/video_img_black.a7fc270f.svg";